import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, MessageCircle } from "lucide-react";
import { useSettings, whatsappLink } from "@/context/SettingsContext";

export function Footer() {
  const settings = useSettings();
  const wa = whatsappLink(settings.whatsapp_number, "Hello Shineni India, I have a bulk denim requirement.");

  return (
    <footer className="bg-indigo-deep text-white/80" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-baseline gap-2">
            <span className="font-display text-2xl font-bold tracking-wide text-white">SHINENI</span>
            <span className="font-display text-xs font-semibold tracking-[0.35em] text-gold">INDIA</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed">
            A brand operated by <span className="text-white">Madneel Ventures Pvt. Ltd.</span>
          </p>
          <p className="mt-2 flex items-start gap-2 text-sm">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
            {settings.address || "Faridabad, Haryana, India"}
          </p>
          <p className="mt-3 text-xs tracking-wide text-gold">Made in India</p>
        </div>

        <div>
          <h3 className="font-display text-sm font-semibold uppercase tracking-widest text-gold">Products</h3>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link className="transition-colors hover:text-white" to="/womens-jeans">Women's Jeans</Link></li>
            <li><Link className="transition-colors hover:text-white" to="/mens-jeans">Men's Jeans</Link></li>
            <li><Link className="transition-colors hover:text-white" to="/kids-jeans">Kids' Jeans</Link></li>
            <li><Link className="transition-colors hover:text-white" to="/oem-private-label">OEM &amp; Private Label</Link></li>
            <li><Link className="transition-colors hover:text-white" to="/products">Full Catalogue</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-display text-sm font-semibold uppercase tracking-widest text-gold">For Buyers</h3>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link className="transition-colors hover:text-white" to="/indian-wholesale">Indian Wholesale</Link></li>
            <li><Link className="transition-colors hover:text-white" to="/international-export">International Export</Link></li>
            <li><Link className="transition-colors hover:text-white" to="/capabilities">Manufacturing Capabilities</Link></li>
            <li><Link className="transition-colors hover:text-white" to="/request-a-quote">Request a Quote</Link></li>
            <li><Link className="transition-colors hover:text-white" to="/about">About Us</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-display text-sm font-semibold uppercase tracking-widest text-gold">Contact</h3>
          <ul className="mt-4 space-y-3 text-sm">
            {settings.business_email && (
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-gold" />
                <a className="transition-colors hover:text-white" href={`mailto:${settings.business_email}`}>{settings.business_email}</a>
              </li>
            )}
            {settings.phone && (
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-gold" />
                <a className="transition-colors hover:text-white" href={`tel:${settings.phone.replace(/[^0-9+]/g, "")}`}>{settings.phone}</a>
              </li>
            )}
            {wa && (
              <li className="flex items-center gap-2">
                <MessageCircle className="h-4 w-4 text-gold" />
                <a className="transition-colors hover:text-white" href={wa} target="_blank" rel="noopener noreferrer">WhatsApp us</a>
              </li>
            )}
            {!settings.business_email && !settings.phone && !wa && (
              <li className="text-white/60">Reach us through the enquiry form — our team responds to every serious requirement.</li>
            )}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-6 text-xs text-white/50 sm:px-6 md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} Madneel Ventures Pvt. Ltd. Shineni India is a brand operated by Madneel Ventures Pvt. Ltd.</p>
          <div className="flex flex-wrap items-center gap-4">
            {settings.gst && <span>GST: {settings.gst}</span>}
            {settings.iec && <span>IEC: {settings.iec}</span>}
            <Link className="transition-colors hover:text-white" to="/privacy-policy">Privacy Policy</Link>
            <Link className="transition-colors hover:text-white" to="/terms">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
